import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Compass } from "lucide-react";

const QUIZ_BG = "https://customer-assets.emergentagent.com/job_atelier-tall/artifacts/rog5ibph_ChatGPT%20Image%20May%2019%2C%202026%2C%2001_15_48%20PM.png";

export const QuizBanner = () => (
  <section className="relative overflow-hidden" data-testid="home-quiz-banner">
    <div className="absolute inset-0">
      <img src={QUIZ_BG} alt="" className="w-full h-full object-cover" style={{ objectPosition: "center 30%" }} />
      <div className="absolute inset-0 bg-[#f0e9e1]/72" />
    </div>
    <div className="relative max-w-[1440px] mx-auto px-5 sm:px-6 lg:px-12 py-20 sm:py-32 grid grid-cols-12 gap-6">
      <div className="col-span-12 lg:col-span-7 fade-up">
        <div className="micro-label text-[#1a1814]/70 mb-5 sm:mb-6 inline-flex items-center gap-2">
          <Compass className="w-3 h-3" /> Fit Counsel
        </div>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-7xl text-[#1a1814] leading-[1] sm:leading-[0.98] max-w-2xl">
          Tell us your height. We'll <em className="italic">draft you</em> a capsule.
        </h2>
        <p className="text-[#1a1814]/75 mt-6 sm:mt-8 max-w-md leading-relaxed text-sm sm:text-base">
          Five quiet questions — five minutes. We'll return with three pieces graded to your stature, palette and pace.
        </p>
        <Link
          to="/fit-quiz"
          className="inline-flex items-center justify-center gap-3 mt-8 sm:mt-10 bg-[#1a1814] text-[#f0e9e1] px-8 sm:px-10 py-4 micro-label hover:bg-[#1a1814]/85 w-full sm:w-auto"
          data-testid="home-quiz-cta"
        >
          Take the Fit Quiz <ArrowRight className="w-4 h-4" strokeWidth={1.25} />
        </Link>
      </div>
    </div>
  </section>
);
